/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { BUNDLER, ETHERSPOT } from '../../consts/bundlers'
import { Network } from '../../interfaces/network'
import { Bundler } from './bundler'
import { GasSpeeds, UserOpStatus } from './types'

export class Etherspot extends Bundler {
  protected getUrl(network: Network): string {
    const API_KEY = process.env.REACT_APP_ETHERSPOT_API_KEY || ''

    if (!API_KEY) {
      throw new Error('Etherspot API key is not set')
    }

    return `https://rpc.etherspot.io/v2/${network.chainId.toString()}?api-key=${API_KEY}`
  }

  protected async getGasPrice(network: Network): Promise<GasSpeeds> {
    const provider = this.getProvider(network)
    const prices: any = await provider.send('skandha_getGasPrice', [])
    return {
      slow: {
        maxFeePerGas: prices.maxFeePerGas,
        maxPriorityFeePerGas: prices.maxPriorityFeePerGas
      },
      medium: {
        maxFeePerGas: prices.maxFeePerGas,
        maxPriorityFeePerGas: prices.maxPriorityFeePerGas
      },
      fast: {
        maxFeePerGas: prices.maxFeePerGas,
        maxPriorityFeePerGas: prices.maxPriorityFeePerGas
      },
      ape: {
        maxFeePerGas: prices.maxFeePerGas,
        maxPriorityFeePerGas: prices.maxPriorityFeePerGas
      }
    }
  }

  public async getStatus(network: Network, userOpHash: string): Promise<UserOpStatus> {
    const provider = this.getProvider(network)

    const status = await provider.send('eth_getUserOperationReceipt', [userOpHash]).catch((e) => {
      // eslint-disable-next-line no-console
      console.log('etherspot failed to find the status of the user op')
      // eslint-disable-next-line no-console
      console.log(e)

      return null
    })

    if (!status || !status.receipt) {
      return {
        status: 'not_found'
      }
    }

    return {
      status: 'found',
      transactionHash: status.receipt.transactionHash
    }
  }

  public getName(): BUNDLER {
    return ETHERSPOT
  }

  public shouldReestimateBeforeBroadcast(network: Network): boolean {
    return false
  }
}
